import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import * as _ from 'lodash';
import {forkJoin, Subscription, zip } from 'rxjs';
import { AccountProfileService } from '../../accountProfile/accountProfileEdit/accountProfileEdit.service';
import { ChangePasswordService } from '../../changePassword/changePassword.service';
import { props } from '../../common/model/properties';
import { FieldValidateService } from '../../common_services/fieldvalidate.service';
import { HeaderService } from '../../header/header.service';
import { Input1Model } from '../../inputComponent/input1.model';
import { SecureStorageService } from '../../secure-storage.service';
import { AlertServiceService } from '../../shared/services/alert-service.service';
import { ConfigProvider } from '../../shared/services/configprovider';
import { CupService } from '../../shared/services/cup.service';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { SigninService } from '../../signin/signin.service';
import { ProviderportalService } from '../providerportal.service';
import {Modal} from 'bootstrap'
import { FormArray, FormBuilder,FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-providerportal',
    templateUrl: './providerportal.component.html',
    styleUrls: ['./providerportal.component.scss'],
    providers: [
        AccountProfileService,
        ChangePasswordService,
        SigninService,
        AlertServiceService,
    ],
    standalone: false
})
export class ProviderportalComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  surveyForm: FormGroup;
  @ViewChild('paragraph') elementView: ElementRef;
  elementHeight: any;
  viewHeight: number;
  inputComps = new Map<string, Input1Model>();
  isCredChangeOptional = false;
  questions1: Array<any>;
  questions2: Array<any>;
  props: any;
  currentItem = 'Television';
  selectedTab = 0;
  subscription: Subscription;
  // cardData =[
  //   {
  //     "AlertId": 302,
  //     "AlertName": "Alerts Testing",
  //     "AlertDetails": "Alerts Testing",
  //     "EffectiveDate": "2020-12-08 00:00:00",
  //     "TerminationDate": "2020-12-13 00:00:00",
  //     "Urgency": "High",
  //     "Severity": "High"
  //   },

  vieAllClicked: boolean = false;
  vieAllClickedforNon: boolean = false;
  userName: any;
  cardData = [];
  saveAlertId: any;
  copyCardData = [];
  copyOfcardData: any;
  isUnReadValue: boolean;
  unReadAlertCount: any;
  brodcastCloseFlag: boolean = false;
  diffDays: any;
  isProviderPortalSurveyPending: boolean;
  sideBtnVisibility: boolean;
  providerSurveyQuestions: any[];
  providerSurveyRatings: any[];
  selectedProviderModel: any;
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  providers: any[];
  providerList: any[];
  // isPCP: boolean;
  sites: any;
  selectedSite: any;
  showSpinner: boolean;
  selectedProduct: string;
  surveySubmittedData=[];
  isSurveySubmitted:boolean=false;
  allProviderSiteDate=[];
  warningsMsgs=[];
  currentIndex=0;
  private prpModules;
  checkForTrainingsPrpModuleId:any;
  addItem(newItem: any) {
    this.selectedTab = newItem.index;
  }
  public checkEmergency() {
    this.selectedTab = 1;
  }
  public checkNonEmergencyTab() {
    this.selectedTab = 2;
  }
  ngOnDestroy() {
    this.cardData = [];
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  constructor(
    private alertService: AlertServiceService,
    private cdRef: ChangeDetectorRef,
    private changeCredService: ChangePasswordService,
    private accountProfileService: AccountProfileService,
    private currentService: ProviderportalService,
    private router: Router,
    private elRef: ElementRef,
    private fieldValidator: FieldValidateService,
    private userIdle: UserIdleService,
    private cupService: CupService,
    private configProvider: ConfigProvider,
    private _signinservice: SigninService,
    private sanitizer: DomSanitizer,
    private secureStorage: SecureStorageService,
    private headerService: HeaderService,
    private urlconstantsService: UrlconstantsService,
    private fb: FormBuilder,
    private providerportalService: ProviderportalService
  ) {
    this.props = configProvider.getProps();
    //  this.getAllAlerts();
  }

  attestedIds = [];
  headerInfo: any = '';
  userJson: any = '';
  errorMessage: any = '';
  showSection = 'tabSection';
  notificationList = ['changePassword', 'setQuestions', 'showBroadcast','showWarningMsg'];
  currentNotification = -1;
  html = `<div class="row"><div class="col-md-3">Hello wolrd</div> <div class="col-md-3">Hello wolrd</div> <div class="col-md-3">Hello wolrd</div> <div class="col-md-3">Hello wolrd</div>
      </div>`;

  tokenModel = {};
  broadcast = [];
  warning = [];
  headerMsg = [];
  msgName = [];
  que1 = 'Question1';
  ans1 = '';
  que2 = 'Question2';
  ans2 = '';
  isQuestion1Valid = true;
  isQuestion2Valid = true;
  isAns1Valid = true;
  isAns2Valid = true;
  userError: any = 'false';
  userErrorMessage: any;
  credChangeDate: any;
  current_date: any;
  failureMessage: string;
  successMessage: string;
  showClose = true;

  //loading = false;  -- check this
  loading = true;
  shouldDisableClick = true;
  showCred = true;
  UserCred: any = '';
  isValidCred = true;
  message: any;
  que1Val: any;
  que2Val: any;
  notifytext: any;
  userNoSitesInfo =
  'User verification in progress. Please contact your account operator to add you to the provider site through site administration. If the account operator is unable to resolve the issue then please contact CareMore Health Provider Relations at (888) 291-1358 or send an email to ProviderRelations@caremore.com.';
  broadcastMessage: any;
  buttonDisabled: boolean = true;
  divHeight: any;
  parentHeight: any;
  getName: any;
  data = [];
  handleResults(searchObj) {
    this.data = searchObj;
  }

  ngAfterViewInit() {
    //console.log('ngAfterViewInit');
    const div = this.elRef.nativeElement.querySelector('mc-breadcrumbs');
    // this.elRef.nativeElement.querySelector('#tile1sub').style.display = 'none';
    //this.elRef.nativeElement.querySelector('#tile1subArrow').style.display =
    // 'none';

    this.userError =
      this.secureStorage.getSecureInfoInSessionStorage('userError');
    this.userErrorMessage =
      this.secureStorage.getSecureInfoInSessionStorage('userErrorMessage');
    this.cdRef.detectChanges();

  

    this.currentService.getBroadcast((success: boolean, broadcast: any) => {
      if (success) {
        this.broadcast = broadcast['providerPortalBroadcast'];
        if (this.broadcast.length > 0) {
          this.secureStorage.setSecureInfoInSessionlStorage(
            'mybroadcastMessage',
            this.broadcast[0].message
          );
          this.getName =
            this.secureStorage.getSecureInfoInSessionStorage('elementHeight');
          if (this.getName <= 30) {
            this.buttonDisabled = true;
          } else {
            this.buttonDisabled = false;
          }
        }
      }
    });

    
  }

  showfullContent() {
    (document.querySelector('.broadMessage') as HTMLElement).style.height =
      'auto';
    (document.querySelector('.broadcastBody') as HTMLElement).style.overflow =
      'auto';
    (document.querySelector('.viewMoreBtn') as HTMLElement).style.display =
      'none';
  }
  myModalEventCallBack() {}

  viewMore() {
    // jQuery('.content p').addClass('viewMore');
    document.querySelectorAll('.content p').forEach(paragraph => {
      paragraph.classList.add('viewMore');
    });

  }

  // checkForTrainings(){
  //   this.diffDays = '';
  //   this.currentService.getWarningMsgs((success: boolean, warning: any) => {
  //     if(success) {
  //       this.warning = warning['providerPortalBroadcast'];
  //       if(this.warning.length > 0) {
  //         const currentDate:any = new Date();
  //         const targetDate:any = new Date(this.warning[0].targetDate);
  //         if (targetDate > currentDate) {
  //           const diffTime = Math.abs(currentDate - targetDate);
  //           this.diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  //           jQuery('#trainingModal').modal('show');
  //         }
  //         else {
  //           console.log("target date is greater then current date")
  //         }
  //       }
  //     }
  //   })
  // }

  async getNextNotification() {
    this.onCloseModal( this.notificationList[this.currentNotification] + 'Modal')

    const nextNotification = this.currentNotification + 1;
    if (nextNotification === this.notificationList.length) {
      this.secureStorage.setSecureInfoInSessionlStorage(
        'dontShowNotifications',
        'true'
      );
      this.checkForTrainings();
      return;
    }
    this.currentNotification = nextNotification;
    const type = this.notificationList[this.currentNotification];
    if (type === 'changePassword') {
      try {
        this.credChangeDate = JSON.parse(
          this.secureStorage.getSecureInfoInSessionStorage('userProfile')
        )['cred'];
      } catch (e) {
        let loginresp3 = await this.accountProfileService.getUserProfile2('');
        let resp3 = loginresp3.user[0];
        this.providerportalService.setUserData(resp3);
        this.secureStorage.setSecureInfoInSessionlStorage(
          'userProfile',
          JSON.stringify({
            city: resp3.city,
            zip: resp3.zip,
            state: resp3.state,
            userRole: resp3.userRole,
            guId: resp3.guId,
            phone: resp3.phone,
            extn: resp3.extn,
            fax: resp3.fax,
            email: resp3.email,
            npi: resp3.npi,
            taxid: resp3.taxId,
            questions: resp3.securityQuestionsFlag,
            cred: resp3.lastPasswordChange,
            lastLogin: resp3.currentLogin,
            loginTimePayloadTime: resp3.lastLogin,
            userClass: resp3.userClass,
          })
        );
        try{
           this.credChangeDate = JSON.parse(
           this.secureStorage.getSecureInfoInSessionStorage('userProfile')
           )['cred'];
           }
           catch(e){
           }
      }

      if (!this.credChangeDate) {
        this.getNextNotification();
        // return;
      } else {
        const cDate = this.credChangeDate.split(' ')[0];
        const pwdLastChangeDateDays =
          (new Date().getTime() - new Date(cDate).getTime()) /
          1000 /
          60 /
          60 /
          24;
        // pwdLastChangeDateDays = 181
        if (pwdLastChangeDateDays <= 165) {
          this.getNextNotification();
        } else if (pwdLastChangeDateDays > 165 && pwdLastChangeDateDays < 180) {
          
          this.openModal('changePasswordModal','static');
          this.isCredChangeOptional = true;
        } else if (pwdLastChangeDateDays >= 180) {
          
          this.openModal('changePasswordModal','static');
          this.isCredChangeOptional = false;
        }
      }
    } else if (type === 'setQuestions') {
      const questionsFlag = JSON.parse(
        this.secureStorage.getSecureInfoInSessionStorage('userProfile')
      )['questions'];
      if (questionsFlag === '0') {
        // this.getQuestions();
        this.getSecurityQuestions();
        this.openModal('setQuestionsModal','static');
        this.secureStorage.setSecureInfoInSessionlStorage('userLogin', 'false');
      } else {
        this.getNextNotification();
      }
    } else if (type === 'showBroadcast') {
      this.getBroadcast();
    }else if (type === 'showWarningMsg') {
      if(this.prpModules.length > 0){
        this.getWarningMsgsDetails();
      }else{
        this.getNextNotification();
      }

    }
  }
  getPRPmodules(){
    return this.currentService.getPRPModules().toPromise();

  }
  async getWarningMsgsDetails() {
    const promises = this.prpModules.map((element) => {
      if (element.moduleUid === 1 && element.moduleName === 'TRAINING AND ATTESTATION') {
        return Promise.resolve();
      }
      return new Promise<void>((resolve) => {
        this.currentService.getWarningMsgs(element.moduleUid.toString(), (success: boolean, warning: any) => {
          if (success) {
            if (warning.providerPortalBroadcast.length > 0) {
               const broadcast=warning.providerPortalBroadcast[0];
              if(broadcast.moduleName=='PAHAF'){
                    resolve()
                    return
              }
              this.warningsMsgs.push(broadcast);
            }
          }
          resolve();
        });
      });
    });
  
    await Promise.all(promises);
  
    if (this.warningsMsgs.length > 0 && this.currentIndex < this.warningsMsgs.length) {
      this.openModal('warningAlearts', 'static');
    } else {
      this.getNextNotification();
    }
  }
  nextWarningMsg(id: any) {
    const modalElement = document.getElementById(id);
    const modal = Modal.getInstance(modalElement);
    if (modal != null) {
        modal.hide();
        modalElement.addEventListener('hidden.bs.modal', () => {
            this.showNextModal();
        }, { once: true });
    } else {
        this.showNextModal();
    }
}
showNextModal() {
  this.currentIndex++;
  if (this.currentIndex <= this.warningsMsgs.length - 1) {
      this.openModal('warningAlearts', 'static');
  } else {
      this.getNextNotification();
  }
}

  async template1() {
    if (this.userError && this.userError === 'true') {
      this.openModal('noSiteModal');
      return;
    }
    const isValid = await this.providerportalService.checkCupTokenValidity();
  if (!isValid) {
      this.openModal('CupJwtErrMsg')
      return;
    }
    this.secureStorage.setSecureInfoInLocalStorage('targetUrl', 'member');
    window.open('../CUPPortal/#/singlesignon', '_balnk');
  }

  async template2() {
    const isValid = await this.providerportalService.checkCupTokenValidity();
  if (!isValid) {
      this.openModal('CupJwtErrMsg')
      return;
    }
    this.secureStorage.setSecureInfoInLocalStorage('targetUrl', 'member');
  }

  async template3() {
    if (this.userError && this.userError === 'true') {
      this.openModal('noSiteModal');
      return;
    }
    const isValid = await this.providerportalService.checkCupTokenValidity();
  if (!isValid) {
      this.openModal('CupJwtErrMsg')
      return;
    }
    this.secureStorage.setSecureInfoInLocalStorage('targetUrl', 'provider');
    window.open('../CUPPortal/#/singlesignon', '_blank');
  }

  async template4() {
    if (this.userError && this.userError === 'true') {
      this.openModal('noSiteModal');
      return;
    }
    const isValid = await this.providerportalService.checkCupTokenValidity();
  if (!isValid) {
      this.openModal('CupJwtErrMsg')
      return;
    }
    this.secureStorage.setSecureInfoInLocalStorage(
      'targetUrl',
      'general/view-authorization'
    );
    window.open('../CUPPortal/#/singlesignon', '_blank');
  }

  async template7() {
    if (this.userError && this.userError === 'true') {
      this.openModal('noSiteModal');
      return;
    }
    const isValid = await this.providerportalService.checkCupTokenValidity();
  if (!isValid) {
      this.openModal('CupJwtErrMsg')
      return;
    }
    this.secureStorage.setSecureInfoInLocalStorage(
      'targetUrl',
      'general/diagnosis-search'
    );
    window.open('../CUPPortal/#/singlesignon', '_blank');
  }

  async template5() {
    if (this.userError && this.userError === 'true') {
      this.openModal('noSiteModal');
      return;
    }
    const isValid = await this.providerportalService.checkCupTokenValidity();
  if (!isValid) {
      this.openModal('CupJwtErrMsg')
      return;
    }
    this.openModal('viewMemberClaimsModal');
    event.preventDefault();
  }
  async template6() {
    if (this.userError && this.userError === 'true') {
      this.openModal('noSiteModal');
      return;
    }
    const isValid = await this.providerportalService.checkCupTokenValidity();
  if (!isValid) {
      this.openModal('CupJwtErrMsg')
      return;
    }
    event.preventDefault();
    this.openModal('submitMemberAuthModal');
  }
  async modalClose(id:any) {
    this.onCloseModal(id)
    const isValid = await this.providerportalService.checkCupTokenValidity();
    if (!isValid) {
      this.openModal('CupJwtErrMsg')
      return;
    }
    window.open('../CUPPortal/#/singlesignon', '_blank');
    this.secureStorage.setSecureInfoInLocalStorage('targetUrl', 'member');
  }

  // async checkForTrainings(){
  //   this.loading = true;
  //   this.diffDays = '';
  //   let  urlConstant: any = this.urlconstantsService.fetchUrl();
  //   this.attestedIds = []
  //   const siteDetailURL = urlConstant.userSiteProviders.replace(
  //     '{id}',
  //     JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('currentUser')).userName
  //   );

  //   let providerData$ =  this.cupService.retrieveData('post', siteDetailURL);
  //   let attestedIds$ =this.currentService.getAttestedProviders(this.userName)
  //   let zip2 = zip(providerData$,attestedIds$);
  //   zip2.subscribe(async res =>{

  //    let attestedIdsList = (res[1] && res[1].responseDatasArray) ? res[1].responseDatasArray[0].attestations : [];
  //    this.attestedIds = attestedIdsList.map(x=>x.taxId)
  //     let siteData = res[0];
  //     //console.log(siteData)
  //     let providerIds = new Set();
  //     if (siteData && siteData.length) {

  //       siteData.map(each => {
  //         if(each.providers && each.providers.length > 0){

  //         each.providers.map(element => {
  //           if ( element.region.indexOf("OBSOLETE") === -1) {
  //           providerIds.add(element.npi);
  //           }
  //         })}})
  //         let isTrainingCompleted2 = Array.from(providerIds).every(e => this.attestedIds.includes(e));
  //         if(!isTrainingCompleted2){
  //           this.currentService.getWarningMsgs((success: boolean, warning: any) => {
  //             if(success) {
  //               this.warning = warning['providerPortalBroadcast'];
  //               if(this.warning.length > 0) {
  //                 this.headerMsg = this.warning[0].messageName;
  //                 this.msgName = this.warning[0].message;
  //                 if(this.warning[0].targetDate) {
  //                   const currentDate:any = new Date();
  //                   const targetDate:any = new Date(this.warning[0].targetDate);
  //                   if (targetDate > currentDate) {
  //                     const diffTime = Math.abs(currentDate - targetDate);
  //                     this.diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  //                     if (this.secureStorage.getSecureInfoInSessionStorage('dnotShowWarningMsg') != 'true') {
  //                       jQuery('#trainingModalWarning').modal('show');
  //                       this.secureStorage.setSecureInfoInSessionlStorage('dnotShowWarningMsg', 'true');
  //                     }
  //                   }
  //                   else {
  //                     jQuery('#trainingModal').modal('show');
  //                   }

  //                 }
  //               }
  //             }
  //           })

  //         }else{
  //           this.headerService.hideMenuSubject.next(false);
  //         }

  //         this.loading = false;
  //     }else{
  //       this.loading = false;
  //     }

  //   },err=>{
  //     this.loading = false;

  //   })
  // }

  public calculateDivHeight(paragraph: HTMLElement): number {
    this.divHeight = paragraph.offsetHeight;
    this.secureStorage.setSecureInfoInSessionlStorage(
      'elementHeight',
      this.divHeight
    );
    this.getName =
      this.secureStorage.getSecureInfoInSessionStorage('elementHeight');
    return this.elementHeight;
  }

  async checkForTrainings() {
    let userNameFromToken = this.cupService.getUserNameFromJWT();
    this.loading = true;
    this.diffDays = '';
    let urlConstant: any = this.urlconstantsService.fetchUrl();
    this.attestedIds = [];
    const siteDetailURL = urlConstant.userSiteProviders.replace(
      '{id}',
      userNameFromToken
    );
    let providerData$ = this.cupService.retrieveData('post', siteDetailURL);
    let attestedIds$ = this.currentService.getAttestedProviders(this.userName);
    let zip2 = zip(providerData$, attestedIds$);
    zip2.subscribe(
      async (res) => {
        let attestedIdsList =
          res[1] && res[1].responseDatasArray
            ? res[1].responseDatasArray[0].attestations
            : [];
        this.attestedIds = attestedIdsList.map((x) => x.taxId);
        let siteData = res[0];
        this.allProviderSiteDate=siteData;
        ////console.log(siteData)
        let providerIds = new Set();
        if (siteData && siteData.length) {
          for (const each of siteData) {
            let providerSiteInfo = await this.currentService.getProviderSiteInfo(each.siteUid).toPromise();
            
            
            if (each.providers && each.providers.length > 0) {
              for (const element of each.providers) {
                if (element.region.indexOf('OBSOLETE') === -1) {
                  let termDate = new Date(element?.termDate)
                  if(termDate.getTime()>= new Date().getTime()){
                    let isContracted = false;
                    if (providerSiteInfo && providerSiteInfo.siteProviders && providerSiteInfo.siteProviders.length > 0) {
                      const siteProvider = providerSiteInfo.siteProviders.find(sp => sp.providerId === element.providerId);
                      if (siteProvider && siteProvider.providerStatus === 'Contracted') {
                        isContracted = true;
                      }
                    }
                    if (isContracted) {
                      if (element.npi && !isNaN(Number(element.npi))) {
                        providerIds.add(element.npi);
                      }
                    }
                  }
                }
              }
            }
          }
          let isTrainingCompleted2 = Array.from(providerIds).every((e) =>
            this.attestedIds.includes(e)
          );
          if (!isTrainingCompleted2) {
            this.currentService.getWarningMsgs(this.checkForTrainingsPrpModuleId,
              (success: boolean, warning: any) => {
                if (success) {
                  this.warning = warning['providerPortalBroadcast'];
                  if (this.warning.length > 0) {
                    this.headerMsg = this.warning[0].messageName;
                    this.msgName = this.warning[0].message;
                    if (this.warning[0].targetDate) {
                      const currentDate: any = new Date();
                      const targetDate: any = new Date(
                        this.warning[0].targetDate
                      );
                      if (targetDate > currentDate) {
                        const diffTime = Math.abs(currentDate - targetDate);
                        this.diffDays = Math.ceil(
                          diffTime / (1000 * 60 * 60 * 24)
                        );
                        if (
                          this.secureStorage.getSecureInfoInSessionStorage(
                            'dnotShowWarningMsg'
                          ) != 'true'
                        ) {
                          // jQuery('#trainingModalWarning').modal('show');
                          this.openModal('trainingModalWarning',"static");
                          this.secureStorage.setSecureInfoInSessionlStorage(
                            'dnotShowWarningMsg',
                            'true'
                          );
                        }
                      } else {
                        this.openModal('trainingModal',"static");
                      }
                    }
                  }
                }
              }
            );

            //----------------------
          } else {
            this.headerService.hideMenuSubject.next(false);
          }

          this.loading = false;
        } else {
          this.loading = false;
        }
      },
      (err) => {
        this.loading = false;
      }
    );
  }


  async ngOnInit() {
    this.loading = true;
    try {
    this.prpModules = await this.getPRPmodules();
  
      if (this.prpModules && this.prpModules.modulesList) {
        this.prpModules = this.prpModules.modulesList;
  
        if (this.prpModules.length > 0) {
          this.prpModules.forEach((element) => {
            if (element.moduleName === 'TRAINING AND ATTESTATION') {
              this.checkForTrainingsPrpModuleId = element.moduleUid.toString();
            }
          });
        } else {
          this.checkForTrainingsPrpModuleId = '1';
        }
      } else {
        this.prpModules = [];
      }
    } catch (error) {
      this.prpModules = [];
    }
    this.getProviderSurveyQuestionsAndRating();
    this.providerSurveySubmittedRecord();
    // this.isPCP = null;
    this.init();
    this.sideBtnVisibility=false;
    this.isProviderPortalSurveyPending=false;
    this.isProviderPortalSurveyPending=this.providerportalService.isSurveyHide();
    this.sideBtnVisibility=this.providerportalService.getSurveySideBtnVisibility();
    this.loading = true;
    //this.cupService.initRefreshJWTTimer();
    // this.alertService.getDataFromDB();
    this.userName = this.cupService.getUserNameFromJWT();
    this.getAllAlerts();
    if (!this.cardData) this.cardData = [];
    this.currentService.getBroadcast((success: boolean, broadcast: any) => {
      if (success) {
        this.broadcast = broadcast['providerPortalBroadcast'];

        if (this.broadcast.length > 0) {
          this.secureStorage.setSecureInfoInSessionlStorage(
            'mybroadcastMessage',
            this.broadcast[0].message
          );
        }
      }
    });
    // this.cardData = alertModelData;
    const userJsonObj = JSON.parse(
      this.secureStorage.getSecureInfoInSessionStorage('PP_access_token')
    );
    if (userJsonObj) {
      this.userJson = userJsonObj;
    }
    const kvpl = [];
    this.currentService.listDocuments('GEN_REF_DOC', kvpl, 1, 100);

    this.inputComps.set(
      'oldPassword',
      new Input1Model({
        displayType: 'ONE',
        label: 'Old Password',
        value: '',
        type: Input1Model.TYPE_OLD_CRED,
        required: true,
      })
    );
    this.inputComps.set(
      'newPassword',
      new Input1Model({
        displayType: 'ONE',
        label: 'New Password',
        value: '',
        minLength: 8,
        maxLength: 15,
        type: Input1Model.TYPE_CRED,
        required: true,
      })
    );
    this.inputComps.set(
      'confirmPassword',
      new Input1Model({
        displayType: 'ONE',
        label: 'Confirm Password',
        value: '',
        minLength: 8,
        maxLength: 15,
        type: Input1Model.TYPE_CRED,
        required: true,
      })
    );

    this.loading = false;
    try {
      setTimeout(() => {
        Array.from(document.getElementsByClassName('disable-page')).forEach(
          (el) => el.classList.remove('disable-page')
        );
      }, 500);
    } catch (e) {}
    const dontShowNotifications =
      this.secureStorage.getSecureInfoInSessionStorage('dontShowNotifications');
    if (!dontShowNotifications || dontShowNotifications === 'false') {
      this.getNextNotification();
    } else {
      this.checkForTrainings();
    }

    this.subscription = this.alertService.message.subscribe((message) => {
      let incomingAlerts = _.cloneDeep(message);
      this.isUnReadValue = true;
      let finalData = [];
      if (
        incomingAlerts &&
        Array.isArray(incomingAlerts) &&
        incomingAlerts.length
      ) {
        let newAlerts = _.differenceBy(
          incomingAlerts,
          this.cardData,
          'AlertId'
        );
        if (
          newAlerts &&
          newAlerts.length &&
          Array.isArray(this.cardData) &&
          this.cardData.length > 0
        ) {
          finalData = [...newAlerts, ...this.cardData];
        } else if (
          this.cardData &&
          this.cardData.length === 0 &&
          incomingAlerts &&
          incomingAlerts.length
        ) {
          finalData = incomingAlerts;
        } else if (this.cardData && this.cardData.length) {
          finalData = this.cardData;
        }
        if (
          newAlerts.length === 0 &&
          !_.isEqual(this.cardData, incomingAlerts)
        ) {
          let allNeedToChange = this.cardData.every((temp) => {
            return temp.IsUnRead === '0';
          });
          if (allNeedToChange) finalData = incomingAlerts;
        }
        if (!_.isEqual(this.cardData, incomingAlerts)) {
          incomingAlerts.forEach((each: any, index) => {
            if (each.isCardOpened) {
              let openCard = _.findIndex(this.cardData, {
                AlertId: each.AlertId,
              });
              this.cardData.splice(openCard, 1, each);
            }
          });
        }
        setTimeout(() => {
          this.cardData = finalData;
          //  this.unReadAlertCounts();
          this.isUnReadValue =
            finalData.length === 0
              ? true
              : this.cardData.every((temp) => {
                  return temp.IsUnRead === '0';
                });
        }, 10);
      }
    });
    this.loading = false;
    //   try{
    //     setTimeout(()=>{
    //       Array.from(document.getElementsByClassName("disable-page")).forEach(el =>
    //         el.classList.remove('disable-page')
    //         )
    //     },1000)
    //   }
    // catch(e){}
    this.alertService.setInterValCAllingForAlert();
  }
  init(){
    this.showSpinner=false;
    const o1 = this.getExternalDashboard();

    const zip2 = zip(o1);

    zip2.subscribe(
      (res) => {
        this.externalDashboarSubscribe(res[0]);
        // this.showSpinner = false;
      },
      (err) => {
        // this.showSpinner = false;
      }
    );
  }
  externalDashboarSubscribe(data: any) {
    if (data != null) {
      // this.sites = data.sites;
      if (data.sites && data.sites.length) {
        data.sites.map((element) => {
          this.sites.push({
            id: element.siteUid,
            value: element.siteName,
            label: element.siteName,
          });
        });
      }
    }
  }
  getExternalDashboard() {
    this.sites = [];
    //this.pcpscorecard = false;
    const username = this.cupService.getUserNameFromJWT();
    const url = this.urlConstant.providerDashboard;
    return this.cupService.retrieveData('post', url);
  }
  setProviders(e:any){
    this.surveyForm.reset();
    this.showSpinner=true;
    this.selectedProduct='';
    // this.isPCP = null;
    this.isSurveySubmitted = false;
    this.providerList = [];
  this.selectedSite=e;
  // this.getPCPProviders();
  setTimeout(() => { 
    this.getAllprovidersRelatedToSite(this.selectedSite.id)
   }, 1000);
  }
  getPCPProviders() {
    const userNameFromToken = this.cupService.getUserNameFromJWT();
    this.providers = [];
    const siteDetailURL = this.urlConstant.userSiteGet.replace(
      '{siteUid}',
      this.selectedSite.id
    );
    let checkDuplicates = [];
    this.cupService.retrieveData('get', siteDetailURL).subscribe(
      (siteData) => {
        if ( siteData.siteProviderConfig && !_.isEmpty(siteData.siteProviderConfig)) {
          this.showSpinner = false;
            siteData.siteProviderConfig.map((element) => {
              if ( element.region.indexOf('OBSOLETE') === -1) {
                element.itemName =
                  element.name +
                  '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                  element.region +
                  '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                  element.address.substring(0, 14);
                element.providerUid = element.id;
                element.id = element.providerId;
                if (!checkDuplicates.includes(element.itemName)) {
                  checkDuplicates.push(element.itemName);
                  this.providers.push(element);
                }
              }
            });
            // this.selectedProvider = this.providers[0];
            // this.onProvidersSubmit(this.selectedProvider);
            this.providerList = this.providers;
            
          } else {
            // this.diseasesList = [];
            this.showSpinner = false;
          }
        },(error) => {
          this.showSpinner = false;  
      }
    );
  }
  getAllprovidersRelatedToSite(siteId:any){
    let checkDuplicates=[];
    this.providers = [];
    this.allProviderSiteDate.forEach(site => {

      if(site.siteUid == siteId && site.providers && site.providers.length>0){
        this.showSpinner=false;
        site.providers.forEach(element => {
          if ( element.region.indexOf('OBSOLETE') === -1) {
            let ispcp=element.pcp?"pcp":"nonpcp;"
            element.itemNameWithisPCP =
            element.name +
              '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
              element.region +
              '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
              element.address.substring(0, 14) +
              '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
              ispcp;
              element.itemName =
            element.itemName =
            element.name +
              '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
              element.region +
              '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
              element.address.substring(0, 14);
              element.providerUid = element.id;
              element.id = element.providerId;
            if (!checkDuplicates.includes(element.itemNameWithisPCP)) {
              checkDuplicates.push(element.itemNameWithisPCP);
              this.providers.push(element);
            }
          }
        });
      }else{
        this.showSpinner=false;
        this.providerList = [];
      }
    });
    const itemNameMap= new Map<string , {count:number,hasPCPTrue:boolean}>();
this.providers.forEach(item => {
 if(!itemNameMap.has(item.itemName)){
   itemNameMap.set(item.itemName,{count:0,hasPCPTrue:false});
  }
  let entry = itemNameMap.get(item.itemName);
  entry.count++;
  if(item.pcp){
    entry.hasPCPTrue=true;
  }

});
const pushedItemNames=new Set();
this.providers.forEach(item => {
  let entry = itemNameMap.get(item.itemName);
  if(entry.count>1){
    if(entry.hasPCPTrue){
      if(item.pcp){
        this.providerList.push(item);
      }
    }else{
      if(!pushedItemNames.has(item.itemName)){
        this.providerList.push(item);
        pushedItemNames.add(item.itemName);
      }
    }
  }else{
    this.providerList.push(item);
  }
})

  }
  onItemSelect(item:any){
    let checkItem = this.surveySubmittedData.some(record => record.npi === item.npi);
    if(checkItem){
      
      this.isSurveySubmitted = true;

    }else{
      this.isSurveySubmitted = false;
      // this.isPCP = item.pcp?true:false;
    }
    
}
// OnItemDeSelect(item:any){
//     this.isPCP = null;
// }
onDeSelectAll(items: any){
  // this.isPCP = null;
  this.isSurveySubmitted = false;
  this.selectedProduct='';
}
closeSurveyPopup(){
  this.isSurveySubmitted = false;
  this.providerList=[];
  this.selectedSite = null;
  // this.isPCP = null; 
  this.surveyForm.reset();
}
closeModalAlert(id:any){
  this.closeSurveyPopup();
  this.onCloseModal(id);
}
  
  settings = { 
    singleSelection: true, 
    text: "Select Physicians",
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    showCheckbox:false,
    classes:"myclass custom-class"
  }; 
  submitProviderSurvey(){
    
    if (this.surveyForm.valid) {
      this.onCloseModal("providerSurveyModal");
      const formValue = this.surveyForm.value;
      const payload = {
        comment: formValue.comment,
        providerName: formValue.providerName[0].name,
        providerId: formValue.providerName[0].providerId,
        isPCP:formValue.providerName[0].pcp,
        siteUid: formValue.siteUid.id,
        siteName:formValue.siteUid.value,
        surveyRating: this.providerSurveyQuestions.map(question => ({
          typeUid: question.typeUid,
          rating: formValue[question.typeUid]
        })),
        npi:formValue.providerName[0].npi
      };

      this.providerportalService.submitSurveySatisfaction(payload).subscribe(
        (res) => {
          this.openModal("surveySuccessMsg");
          this.surveyForm.reset();
          this.providerList = [];
        },
        (error) => {
          this.openModal("surveyErrorMsg");
          this.surveyForm.reset();
          this.providerList = [];
        }
      );
     
     
      
      
      
      // You can now send the payload to your backend service
    }else{
    }
    // console.log("this.surveyForm.value",this.surveyForm.value);
  }
  getProviderSurveyQuestionsAndRating() {
    forkJoin({
      questions: this.providerportalService.getProviderSurveyQuestions(),
      ratings: this.providerportalService.getProviderSurveyratings()
    }).subscribe(({ questions, ratings }) => {
      this.providerSurveyQuestions = questions;
      this.providerSurveyRatings = ratings;
      this.initializeForm();
    });
  }
  providerSurveySubmittedRecord(){
    
    this.providerportalService.getProviderSurveySubmittedRecord().subscribe((res) => {
      this.surveySubmittedData=res;
    });
  }
  initializeForm(){
    if(this.providerSurveyQuestions.length>0 && this.providerSurveyRatings.length>0){
      this.surveyForm = this.fb.group({
        comment: [''],
        providerName: ['', Validators.required],
        // isPCP: [null, Validators.required],
        siteUid: ['', Validators.required],
        // Dynamically add form controls for each question
        ...this.providerSurveyQuestions.reduce((acc, question) => {
          acc[question.typeUid] = ['', Validators.required];
          return acc;
        }, {})
      });
    }
  }
  doSurveylatter() {
    this.isProviderPortalSurveyPending = false;
    this.sideBtnVisibility = true;
    this.providerportalService.setSurveyClosed(false);
    this.providerportalService.setSurveySideBtnVisibility(true);
    
  }
  navigateToSurveyForm(){
    this.providerSurveySubmittedRecord();
    this.openModal("providerSurveyModal","static");


  }

  logoutAction() {
    localStorage.removeItem('PP_access_token');

    const accessToken = this.secureStorage.getSecureInfoInLocalStorage(
      'clientCredentials_token'
    );
    localStorage.clear();
    this.secureStorage.setSecureInfoInLocalStorage(
      'clientCredentials_token',
      accessToken
    );

    this.router.navigateByUrl('login');
    this.deleteAllDocAttributes();
    sessionStorage.clearAll();
    this.secureStorage.clearStorageData();

  }

  mouseEnter(data) {
    this.elRef.nativeElement.querySelector('#tile1sub').style.display = 'flex';
    this.elRef.nativeElement.querySelector('#tile1subArrow').style.display =
      'flex';
  }

  mouseLeave(data) {
    this.elRef.nativeElement.querySelector('#tile1sub').style.display = 'none';
    this.elRef.nativeElement.querySelector('#tile1subArrow').style.display =
      'none';
  }

  private showAlertPopup(message: string, callBack, showClose = true) {
    this.showClose = showClose;
    this.errorMessage = message;
    this.showPopup('myModal', callBack);
    return;
  }

  private showPopup(popupName: string, callBack) {
    this[popupName + 'EventCallBack'] = callBack;
    this.openModal(popupName,'static');
  }

  updateQuestion() {
    this.que1Val = this.que1.length;
    this.que2Val = this.que2.length;
    this.isQuestion1Valid = true;
    this.isQuestion2Valid = true;
    this.isAns1Valid = true;
    this.isAns2Valid = true;
    this.failureMessage = '';

    if (this.que1 === 'Question1') {
      this.isQuestion1Valid = false;
    }
    if (this.que1Val == 0) {
      this.isQuestion1Valid = false;
    }
    if (this.que2Val == 0) {
      this.isQuestion2Valid = false;
    }
    if (this.ans1 === '') {
      this.isAns1Valid = false;
    }

    if (this.que2 === 'Question2') {
      this.isQuestion2Valid = false;
    }
    if (this.ans2 === '') {
      this.isAns2Valid = false;
    }
    if (this.que1 === this.que2) {
      this.isQuestion1Valid = false;
      this.isQuestion2Valid = false;
      this.openModal('errorModal');
      this.message =
        'Question1 and Question2 should not be same.Please select different questions.';
    }
    if (
      this.isAns2Valid &&
      this.isAns1Valid &&
      this.isQuestion2Valid &&
      this.isQuestion1Valid
    ) {
      this.isQuestion1Valid = true;
      this.isQuestion2Valid = true;
      this.isAns1Valid = true;
      this.isAns2Valid = true;
      this.onCloseModal('setQuestionsModal');
      this.onCloseModal('setQuestionsModal');
      this.openModal('signInModal');
    } else {
      return;
    }
  }

  getBroadcast() {
    console.log('get broadcast');
    if (
      this.secureStorage.getSecureInfoInSessionStorage('dnotShowBroadcast') ===
      'false'
    ) {
      this.currentService.getBroadcast((success: boolean, broadcast: any) => {
        console.log('broadcast----:', broadcast);
        if (success) {
          this.broadcast = broadcast['providerPortalBroadcast'];
          if (this.broadcast.length > 0) {
            const userName: string = this.cupService.getUserNameFromJWT();
            const messageNo: string = this.broadcast[0].messageNo;

            this.currentService.getDND(
              messageNo,
              userName,
              (success: boolean, messagenNo: any) => {
                if (success) {
                  /* jQuery('#showBroadcastModal').modal({
                     backdrop: 'static',
                     keyboard: false
                   });
                   jQuery('#showBroadcastModal').modal('show');
                   return;*/
                }
                this.getNextNotification();
              }
            );
          }
        } else {
        }
      });
    } else {
      this.getNextNotification();
    }
  }

  passwordNotification() {
    this.current_date = new Date().getTime() - 180 * 24 * 60 * 60 * 1000;
    return this.current_date - this.credChangeDate;
  }

  dontShowEvent() {
    this.secureStorage.setSecureInfoInSessionlStorage(
      'dnotShowBroadcast',
      'true'
    );
  }

  disableBroadCast(messageNo: string) {
    const userName: string = this.cupService.getUserNameFromJWT();
    this.currentService.addDND(
      messageNo,
      userName,
      (success: boolean, messagenNo: any) => {
        if (success) {
          this.secureStorage.setSecureInfoInSessionlStorage(
            'dnotShowBroadcast',
            'true'
          );
        }
      }
    );
  }

  changePassword() {
    this.failureMessage = '';
    const oldCred = this.inputComps.get('oldPassword').value;
    const newCred = this.inputComps.get('newPassword').value;
    const confirmCred = this.inputComps.get('confirmPassword').value;
    const userName: string = this.cupService.getUserNameFromJWT();

    if (this.validatePasswordChildInputs()) {
      this.loading = true;
      this.changeCredService.submitPassword(
        oldCred,
        newCred,
        (success: boolean, response: any) => {
          if (success) {
            this.loading = false;
            if (response.status === 'Success') {
              // this.updateUerPasswordChangeTime();
              this.closeNotificationWindow();
              this.showAlertPopup(
                'Your Password has been updated successfully.',
                () => {
                  this.getNextNotification();
                },
                false
              );
            } else {
              this.failureMessage =
                'Sorry something went wrong, please try again later.';
            }

            return;
          } else {
            this.loading = false;
            let respMessage = ' ';
            if (response.status === 401) {
              respMessage =
                'Password is invalid. Please enter a valid password.';
            } else if (response.status === 400) {
              respMessage =
                'This password has been used in recent history. Please choose a different password.';
            } else {
              respMessage =
                'Sorry something went wrong, please try again later.';
            }
            this.failureMessage = respMessage;

            return;
          }
        }
      );
    }
  }

  updateUerPasswordChangeTime() {
    const current_date = new Date();
    const changePasswordTimePayload = {
      userName: this.cupService.getUserNameFromJWT(),
      lastPasswordChange: this.getFormattedDateStr(current_date),
    };
    this.changeCredService.updateUerPasswordChangeTime(
      changePasswordTimePayload,
      (success: boolean, message: string) => {
        if (success) {
          return;
        }
      }
    );
  }

  getFormattedDateStr(date: Date) {
    return (
      date.getFullYear() +
      '-' +
      (date.getMonth() + 1) +
      '-' +
      date.getDate() +
      ' 00:00:00:000'
    );
  }

  validatePasswordChildInputs() {
    this.errorMessage = '';
    const inputComps = this.inputComps;
    const fieldNameArr = ['oldPassword', 'newPassword', 'confirmPassword'];
    let isValid = true;
    for (const fieldName of fieldNameArr) {
      const inputField = inputComps.get(fieldName);
      if (inputField) {
        const isInputValid = inputField.isValid();
        isValid = isValid && isInputValid;
      }
    }
    if (
      !this.fieldValidator.validateCred(inputComps.get('newPassword').value)
    ) {
      inputComps.get('newPassword').fieldValidateMsg =
        'New and Confirm Password should pattern';
      inputComps.get('newPassword').isInputValid = false;
      isValid = false;
      return isValid;
    }
    let newPassword = inputComps.get('newPassword').value;
    const userName = this.cupService.getUserNameFromJWT();
    if (newPassword.length < 8) {
      this.errorMessage = 'Password must be at least 8 characters long.';
      isValid = false;
    } else if (!/[a-z]/.test(newPassword) || !/[A-Z]/.test(newPassword)) {
      this.errorMessage =
        'Password must contain both upper and lower case characters.';
      isValid = false;
    } else if (!/[0-9$!@*?|]/.test(newPassword)) {
      this.errorMessage =
        'Password must contain at least one number or special character ($!@*?|).';
      isValid = false;
    } else if (/[^0-9a-zA-Z$!@*?|]/.test(newPassword)) {
      this.errorMessage = 'Password contains invalid characters.';
      isValid = false;
    } else if (/ {2,}/.test(newPassword)) {
      this.errorMessage = 'Password cannot contain blank spaces.';
      isValid = false;
    } else if (newPassword === userName) {
      this.errorMessage = 'Password cannot be the same as the username.';
      isValid = false;
    } else if (new RegExp(userName.split('').join('.*')).test(newPassword)) {
      this.errorMessage =
        'Password cannot contain three or more consecutive characters of the username.';
      isValid = false;
    } else if (/([a-zA-Z0-9$!@*?|])\1\1/.test(newPassword)) {
      this.errorMessage =
        'Password cannot contain a character or number more than twice in a row.';
      isValid = false;
    }
    if (!isValid) {
      inputComps.get('newPassword').fieldValidateMsg = this.errorMessage;
      inputComps.get('newPassword').isInputValid = false;
      return isValid;
    }
    if (
      inputComps.get('newPassword').value !==
      inputComps.get('confirmPassword').value
    ) {
      inputComps.get('newPassword').fieldValidateMsg =
        'New and Confirm Password should match';
      inputComps.get('confirmPassword').fieldValidateMsg =
        'New and Confirm Password should match';
      inputComps.get('newPassword').isInputValid = false;
      inputComps.get('confirmPassword').isInputValid = false;
      isValid = false;
    }
    return isValid;
  }

  navigateTotraining() {
    this.headerService.hideMenuSubject.next(true);
    this.router.navigate(['/providerportal/provider-training']);
  }

  navigateTotrainingNew() {
    this.router.navigate(['/providerportal/provider-training']);
  }

  closeNotificationWindow() {
    this.onCloseModal(this.notificationList[this.currentNotification] + 'Modal')
  }
  parseResponse(xmlResponse) {
    let returnVal = 'false';
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlResponse, 'text/xml');
    try {
      returnVal =
        xmlDoc.getElementsByTagName('ns:return')[0].childNodes[0].nodeValue;
    } catch (e) {}
    return returnVal;
  }

  parseResponseByName(xmlResponse, tagName) {
    let returnVal = '';
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlResponse, 'text/xml');
    try {
      returnVal =
        xmlDoc.getElementsByTagName(tagName)[0].childNodes[0].nodeValue;
    } catch (e) {}
    return returnVal;
  }

  getSecurityQuestions() {
    let responseData: any;
    this.accountProfileService.getSecurityQuestions().subscribe((response) => {
      responseData = response;
      if (responseData.securityQuestionsResponse) {
        const jsonText = {
          question1: [],
          question2: [],
        };
        responseData.securityQuestionsResponse.forEach((data) => {
          if (data.setNumber === 'QuestionSet1') {
            jsonText['question1'].push(data);
          } else {
            jsonText['question2'].push(data);
          }
        });
        this.questions1 = jsonText['question1'];
        this.questions2 = jsonText['question2'];
      }
    });
  }

  parseXml() {
    const win = window as any;
    if (win.DOMParser) {
      return function (xmlStr) {
        return new win.DOMParser().parseFromString(xmlStr, 'text/xml');
      };
    } else if (
      typeof win.ActiveXObject !== 'undefined' &&
      new win.ActiveXObject('Microsoft.XMLDOM')
    ) {
      return function (xmlStr) {
        const xmlDoc = new win.ActiveXObject('Microsoft.XMLDOM');
        xmlDoc.async = 'false';
        xmlDoc.loadXML(xmlStr);
        return xmlDoc;
      };
    } else {
      return function () {
        return null;
      };
    }
  }

  closeModal() {
    this.onCloseModal('signInModal');
  }
  togglePasswordShow(event: any) {
    this.showCred = !this.showCred;
  }

  onInputFocus(event: any) {
    this.hideValidate(event.target.name);
  }

  passRestrict(event: any) {
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode === 32) {
      event.preventDefault();
    }
  }

  hideValidate(inputName: string) {
    if (inputName === 'password') {
      this.isValidCred = true;
    }
  }
  validatePassword() {
    if (this.UserCred === '') {
      if (this.UserCred === '') {
        this.isValidCred = false;
      }
    } else {
      this.loading = true;
      const userName = this.cupService.getUserNameFromJWT();
      this.currentService.providerGetToken(userName, this.UserCred).subscribe(
        (resp) => {
          this.loading = false;
          this.updateProfileDetails();
        },
        (err) => {
          this.loading = false;
          if (err.status === 500) {
            this.message = 'Server Error, Please click';
            this.onCloseModal('signInModal');
            this.openModal('alertModal');
            // this.showContact = true;
          } else {
            this.message = 'Authentication Failed';
            this.onCloseModal('signInModal');
            this.openModal('alertModal');
          }
        }
      );
    }
  }
  deleteAllDocAttributes() {
    const cookies = document.cookie;

    for (let i = 0; i < cookies.split(';').length; ++i) {
      const myCookie = cookies[i];
      const pos = myCookie.indexOf('=');
      const name = pos > -1 ? myCookie.substr(0, pos) : myCookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    }
  }

  updateProfileDetails() {
    let usernameFromToken = this.cupService.getUserNameFromJWT();
    const authToken = btoa(usernameFromToken + ':' + this.UserCred);
    this.accountProfileService.updateSecurityQuestion(
      this.que1,
      this.que2,
      this.ans1,
      this.ans2,
      this.UserCred,
      (success: boolean, message: string) => {
        if (success) {
          const registerDataPayload = {
            securityQuestionsFlag: '1',
            userName: usernameFromToken,
          };
          this.accountProfileService.updateData(
            registerDataPayload,
            (success: boolean, message: string) => {
              if (success) {
                this.closeNotificationWindow();
                this.onCloseModal('signInModal');
                this.showAlertPopup(
                  'Your security questions has been updated successfully.',
                  () => {
                    this.getNextNotification();
                  },
                  false
                );
              }
            }
          );
        } else {
          this.failureMessage = 'Sorry something went wrong, please try again.';
        }
      }
    );
  }

  closeTokenExpiryPopup() {
    this.onCloseModal('tokenExpiryModal');
    this.currentService.setTokenClearTimeOut(false);
    this.userIdle.stopWatching();
    this.router.navigate(['/login']);
  }
  getAllAlerts() {
    this.isUnReadValue = false;
    this.cardData = _.cloneDeep(this.alertService.allCardData);
    if (
      this.cardData &&
      Array.isArray(this.cardData) &&
      this.cardData.length >= 1
    ) {
      this.isUnReadValue = this.cardData.every((temp: any) => {
        return temp.IsUnRead === '0';
      });
    } else if (
      this.cardData &&
      Array.isArray(this.cardData) &&
      this.cardData.length === 0
    ) {
      this.isUnReadValue = true;
    } else if (!this.cardData) {
      this.isUnReadValue = true;
    } else {
      this.isUnReadValue = false;
    }
  }
  getStatusAlert(alertMetaData) {
    this.currentService
      .getReadStatus(alertMetaData.AlertId)
      .subscribe((response): any => {
        let indexToDel;
        if (response) {
          this.alertService.unReadAlertCounts();
          let CloneOfMainCardArray = _.cloneDeep(this.cardData);
          CloneOfMainCardArray.forEach((alert, index) => {
            if (alert.AlertId === alertMetaData.AlertId) {
              if (alert.open) {
                alert.open = false;
              } else {
                alert['open'] = true;
              }
              if (!alert.isCardOpened) {
                alert['isCardOpened'] = true;
              }

              indexToDel = index;
            }
          });
          setTimeout(() => {
            this.cardData = CloneOfMainCardArray;
            this.alertService.allCardData[indexToDel]['isCardOpened'] = true;
            //this.unReadAlertCounts();
            // For del of alert// this.cardData = CloneOfMainCardArray.splice(indexToDel, 1);
          }, 10);
        }
      });
  }
  brodcastClosed() {
    this.brodcastCloseFlag = true;
  }
  openModal(modalId: string, key?: string) {
    const modalElement = document.getElementById(modalId);
    if (modalElement) {
      let modal;
      if (key != undefined && key != '') {
        modal = new Modal(modalElement, {
          backdrop: 'static',
          keyboard: false
        });
      } else {
        modal = new Modal(modalElement);
      }
      modal.show();
    }
  }
  // callCustomClickFunction(alertToCloseId){
  //   let dataAfterDeletion = [];
  //   this.cardData.forEach((alert,delIndex)=>{
  //     if (alert.AlertId === alertToCloseId) {

  //        this.cardData.splice(delIndex,1);
  //       //console.log( this.cardData);
  //     }
  //   });

  //   //this.cardData = dataAfterDeletion;
  // }
  onCloseModal(modalId){
    const modalElement=document.getElementById(modalId);
    const modal=Modal.getInstance(modalElement);
    if(modal!=null){
      modal.hide();
}
  }
  onCloseSessionOut(modalId){
    const modalElement=document.getElementById(modalId);
    const modal=Modal.getInstance(modalElement);
    if(modal!=null){
      modal.hide();
      this.router.navigateByUrl('/logout');
  }
  
  }
}
